"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var Constants = /** @class */ (function () {
    function Constants() {
    }
    Constants.APP_ENVIRONMENT = process.env.REACT_APP_ENVIRONMENT || 'local';
    Constants.BREAKPOINT = 768;
    Constants.DATE_FORMAT_LONG = 'MMM D, YYYY [at] hh:mma z';
    Constants.EDITOR_DEFAULT_SHARED = {
        allowedContent: 'a[*]{*}; img[*]{*}; font[*]{*}; basefont[*]{*}; div[*]{*}; p[*]{*}; span{*};' +
            'br[*]{*}; center[*]{*}; u[*]{*}; b[*]{*}; i[*]{*}; ol[*]{*}; ul[*]{*}; li[*]{*}; strong[*]{*}; em[*]{*};' +
            's[*]{*}; sub[*]{*}; sup[*]{*};' +
            'table[*]{*}; tr[*]{*}; td[*]{*}; thead[*]{*}; tbody[*]{*}; tfoot[*]{*};' +
            'h1[*]{*}; h2[*]{*}; h3[*]{*}; h4[*]{*}; h5[*]{*}; h6[*]{*}; hr[*]{*}',
        disallowedContent: 'audio; body; head; html; iframe; meta; noscript; script; video',
        font_names: 'Arial;Georgia;Impact;Tahoma;Times New Roman;Verdana',
        removeButtons: 'About',
        removeDialogTabs: 'link:advanced',
        removePlugins: 'elementspath,exportpdf,magicline,resize',
        versionCheck: false,
    };
    Constants.EDITOR_DEFAULT_MODE = __assign({ toolbar: [['Bold', 'Italic', 'Underline']] }, Constants.EDITOR_DEFAULT_SHARED);
    Constants.EDITOR_FULL_MODE = __assign({ toolbar: [
            [
                'Bold',
                'Italic',
                'Underline',
                'Strike',
                'Subscript',
                'Superscript',
                'Format',
                'FontSize',
                'Font',
                'NumberedList',
                'BulletedList',
                'Outdent',
                'Indent',
                'JustifyLeft',
                'JustifyCenter',
                'JustifyRight',
                'JustifyBlock',
                'Link',
                'Unlink',
                'TextColor',
                'BGColor',
                'RemoveFormat',
            ],
            ['Undo', 'Redo'],
            ['Source'],
        ] }, Constants.EDITOR_DEFAULT_SHARED);
    Constants.InternalPrivacyLink = 'https://www.kincentric.com/privacy-policy';
    Constants.PrivacyLink = 'https://msuitelink.com/StaticContent/Documents/KincentricEmployeePrivacy.pdf';
    Constants.LegalLink = 'https://www.kincentric.com/terms-and-conditions';
    Constants.CKEditorFullUrl = 'https://cdn.ckeditor.com/4.16.2/full/ckeditor.js';
    // LOCAL STORAGE KEY
    Constants.LOCAL_STORAGE_CLIENT_CONFIRMED = 'ClientConfirmed';
    Constants.CHINA_DOMAIN_NAME = 'modernsurvey.cn';
    Constants.CHINA_ENTITY_NAME = '思澎赛企业管理（上海）有限公司 plc';
    Constants.CHINA_ICP_LINK = 'http://www.beian.miit.gov.cn/';
    Constants.CHINA_ICP_NUMBER = '沪ICP备19035856号-2';
    return Constants;
}());
exports.default = Constants;
